/**
 * Default image URLs used across the app when event/show images are missing.
 */
const DEFAULT_EVENT_IMAGE_URL =
  'https://marqproduction.s3.amazonaws.com/undefined/photo-1492684223066-81342ee5ff30.jpeg-1772890279082';

export default DEFAULT_EVENT_IMAGE_URL;
